// extracted by mini-css-extract-plugin
export default {"floatingButton":"Jz3Gw","key-frames-showing":"fIRn6","absoluteButton":"n7AJz","youngFont":"j5hIW"};